import { latestVideoState } from './latest-video.state';
import { latestVideoActions } from './latest-video.action';
import { latestVideoMutations } from './latest-video.mutation';

export default {
  namespaced: true,
  state: latestVideoState,
  getters: {},
  actions: latestVideoActions,
  mutations: latestVideoMutations,
};
